import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from "@angular/router";
import { QueryService } from "@app/core/queries";
import { of } from "rxjs";

export const queryResolver: ResolveFn<any> =
  (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {

    const id = +route.paramMap.get('id');
    if (!id) {
      return of(null);
    }

    return inject(QueryService).getQueryById(id);
  };